import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { guestGuard } from './core/auth/guest.guard';
import { AdminLayoutComponent } from './core/layout/admin-layout.component';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/presentation/login.page').then((m) => m.LoginPage),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/presentation/dashboard.page').then(
            (m) => m.DashboardPage,
          ),
      },
      {
        path: 'submissions',
        loadComponent: () =>
          import('./features/submissions/presentation/submissions.page').then(
            (m) => m.SubmissionsPage,
          ),
      },
      {
        path: 'raffle',
        loadComponent: () =>
          import('./features/raffle/presentation/raffle.page').then(
            (m) => m.RafflePage,
          ),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./features/reports/presentation/reports.page').then(
            (m) => m.ReportsPage,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
